import CheckIconPinHover from './component'

export default CheckIconPinHover